export default __webpack_public_path__ + "static/11-f91626593de739b1a10ea6afbe10306c.png";